import {ACCESS_DENIED, APP_START, SAVE_VERSION, STARTUP_FAILED} from '../store/actionTypes';
/**
 * action denoting that we should display application (eg we've finished merging of previous store state with actual session context)
 * @return {{type}}
 */
export function startApp(){
    return {
        type: APP_START
    }
}

/**
 * action denoting that the user has no access to Approval (/startup returned 403), so we show the access denied page
 * @return {{type}}
 */
export function accessDenied(){
    return {
        type: ACCESS_DENIED
    }
}

/**
 * action denoting that /startup couldn't be loaded after exhausting retries, so we show the server down page
 * @return {{type}}
 */
export function startupFailed(){
    return {
        type: STARTUP_FAILED
    }
}

export function saveVersion(version) {
    return {
        type: SAVE_VERSION,
        data: version
    }
}